import { render, staticRenderFns } from "./NewKlientItem.vue?vue&type=template&id=5787e423&scoped=true&"
import script from "./NewKlientItem.vue?vue&type=script&lang=js&"
export * from "./NewKlientItem.vue?vue&type=script&lang=js&"
import style0 from "./NewKlientItem.vue?vue&type=style&index=0&id=5787e423&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787e423",
  null
  
)

export default component.exports